<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title16"><h1 class="title">Table of Contents</h1>
</a><div class="toc_entry"><a id="title16"><br/>
</a><span class="toc_entry_titlePage" href="#/e9781439633878_tp01" title="Link target outside of Sample"><span>Title Page</span></span><br/>
<span class="toc_entry_pubInfo" href="#/e9781439633878_cop01" title="Link target outside of Sample"><span>Copyright Page</span></span><br/>
<a class="toc_entry_acknowPage" href="#/e9781439633878_ack01"><span>ACKNOWLEDGMENTS</span></a><br/>
<a class="toc_entry_frontMatter" href="#/e9781439633878_fm02"><span>INTRODUCTION</span></a><br/>
<a class="toc_entry_chapter" href="#/e9781439633878_c01"><span>1 - FRIDAY NIGHT LIGHTS AND SATURDAY’S HEROES</span></a><br/>
<span class="toc_entry_chapter" href="#/e9781439633878_c02" title="Link target outside of Sample"><span>2 - “GET YOUR KICKS . . .”</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439633878_c03" title="Link target outside of Sample"><span>3 - HOOPIN’ IT UP</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439633878_c04" title="Link target outside of Sample"><span>4 - GRAPPLING WITH SUCCESS</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439633878_c05" title="Link target outside of Sample"><span>5 - OUR NATIONAL PASTIME</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439633878_c06" title="Link target outside of Sample"><span>6 - RUNNING, JUMPING, AND THROWING</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439633878_c07" title="Link target outside of Sample"><span>7 - HOORAY FOR OUR SIDE!</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439633878_c08" title="Link target outside of Sample"><span>8 - THE GREAT OUTDOORS</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439633878_c09" title="Link target outside of Sample"><span>9 - OTHER GAMES ON OTHER FIELDS</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439633878_c10" title="Link target outside of Sample"><span>10 - THE NEXT LEVEL</span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439633878_toc01.vue?38a618ae